/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoBottleWineIcon20Solid = forwardRef('FoodDrinkAlcoBottleWineIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1.25C8 .56 8.56 0 9.25 0h1.5C11.44 0 12 .56 12 1.25v4.416c1.766.772 3 2.534 3 4.584v8A1.75 1.75 0 0 1 13.25 20h-6.5A1.75 1.75 0 0 1 5 18.25v-8a5.001 5.001 0 0 1 3-4.584V1.25ZM6.5 11a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-7Z" })));
});
